"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsMapShortcut", function() {
    return {
        restrict : "E",
        scope    : true,
        replace  : true,
        template : require("./obsMapShortcut.html")
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/common/obsMapShortcut.js